import styles from '../../assets/styles/Login/Login.module.scss';
import LeftSide from '../pageComponents/LeftSide';
import { MimaText, MimaButton, MimaInput } from '../../components';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import MimaLogo from '../../assets/img/mima-logo.png';
import AdminLogin from '../../assets/img/admin-login.png';
import { Formik } from 'formik';

function Login({
	switchToSignup,
	switchToForgotPassword,
	validationSchema,
	onSubmit,
	loading,
	owner,
	selectOwnerAccount,
	selectEmployeeAccount,
}) {

	const isBelow1000 = useMediaQuery({
		query: '(max-width: 1000px)',
	});

	return (
		<>
			{isBelow1000 ? (
				<div className={styles.container}>
					<img src={MimaLogo} className={styles.logo} />
					<img src={AdminLogin} className={styles.adminImage} />
					<Formik
							initialValues={{
								email: '',								
								password: '',
							}}
							validationSchema={validationSchema()}
							onSubmit={onSubmit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div className={styles.formCard}>
									<div className={styles.magic}>
										Welcome back, Superhuman <br />
										Ready to make magic happen?
									</div>
									<MimaInput
										labelTitle="Email address"
										type="text"
										placeholder="Enter your email address"
										id="email"
										name="email"
										value={values.email}
										onChange={handleChange('email')}
										onBlur={handleBlur('email')}
										error={errors.email}
										touched={touched.email}
										mb={2}
									/>
									<MimaInput
										labelTitle="Password"
										type="text"
										placeholder="Enter your password"
										id="password"
										name="password"
										value={values.password}
										onChange={handleChange('password')}
										onBlur={handleBlur('password')}
										passwordIcon
										error={errors.password}
										touched={touched.password}
										mb={2}
									/>
									<MimaButton
										title="Login"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										width={38}
									/>
									<MimaText variant="small" align="center" mt={1}>Forgot Password? Contact Super Admin</MimaText>
								</div>
							)}
						</Formik>
				</div>
			) : (
				<div className={styles.container}>
					<div className={styles.leftside}>
						<img src={MimaLogo} className={styles.logo} />
						<MimaText variant="h2" align="center" mb={2}>
							Welcome back, <br />
							Superhuman
						</MimaText>
						<Formik
							initialValues={{
								email: '',								
								password: '',
							}}
							validationSchema={validationSchema()}
							onSubmit={onSubmit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									<MimaInput
										labelTitle="Email address"
										type="text"
										placeholder="Enter your email address"
										id="email"
										name="email"
										value={values.email}
										onChange={handleChange('email')}
										onBlur={handleBlur('email')}
										error={errors.email}
										touched={touched.email}
										mb={2}
									/>
									<MimaInput
										labelTitle="Password"
										type="text"
										placeholder="Enter your password"
										id="password"
										name="password"
										value={values.password}
										onChange={handleChange('password')}
										onBlur={handleBlur('password')}
										passwordIcon
										error={errors.password}
										touched={touched.password}
										mb={2}
									/>
									<MimaButton
										title="Login"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										variant="form"
									/>
									<MimaText variant="small" align="center" mt={1}>Forgot Password? Contact Super Admin</MimaText>
								</div>
							)}
						</Formik>
					</div>
					<div className={styles.rightside}>
						<img src={AdminLogin} className={styles.adminImage} />
						<div className={styles.magic}>
							Ready to make <br />
							magic happen?
						</div>
					</div>
				</div>
			)}
		</>

	);
}

export default Login;
